import type { HiddenWidgetsState } from './hidden-widgets-types';

const HIDDEN_WIDGETS_STORAGE_KEY = 'dabih_hidden_widgets';

/**
 * Lagrer hvilke widgets brukeren har skjult på oversikten.
 * Persistert i localStorage per organisasjon (per nettleser).
 */
export class HiddenWidgetsService {
  private static getStorageKey(organizationId: number): string {
    return `${HIDDEN_WIDGETS_STORAGE_KEY}_${organizationId}`;
  }

  static getHiddenWidgets(organizationId: number): string[] {
    try {
      const data = localStorage.getItem(this.getStorageKey(organizationId));
      if (!data) {
        return [];
      }
      const state: HiddenWidgetsState = JSON.parse(data);
      return state.widgetNames || [];
    } catch (error) {
      console.error('Error reading hidden widgets data:', error);
      return [];
    }
  }

  static hideWidget(organizationId: number, widgetName: string): void {
    try {
      const hiddenWidgets = this.getHiddenWidgets(organizationId);
      if (!hiddenWidgets.includes(widgetName)) {
        hiddenWidgets.push(widgetName);
        this.saveHiddenWidgets(organizationId, hiddenWidgets);
      }
    } catch (error) {
      console.error('Error hiding widget:', error);
    }
  }

  static showWidget(organizationId: number, widgetName: string): void {
    try {
      const hiddenWidgets = this.getHiddenWidgets(organizationId);
      const filtered = hiddenWidgets.filter((name) => name !== widgetName);
      this.saveHiddenWidgets(organizationId, filtered);
    } catch (error) {
      console.error('Error showing widget:', error);
    }
  }

  static isWidgetHidden(organizationId: number, widgetName: string): boolean {
    return this.getHiddenWidgets(organizationId).includes(widgetName);
  }

  private static saveHiddenWidgets(organizationId: number, widgetNames: string[]): void {
    const state: HiddenWidgetsState = {
      widgetNames,
      version: 1,
    };
    localStorage.setItem(this.getStorageKey(organizationId), JSON.stringify(state));
  }

  static clearAll(organizationId: number): void {
    try {
      localStorage.removeItem(this.getStorageKey(organizationId));
    } catch (error) {
      console.error('Error clearing hidden widgets:', error);
    }
  }
}
